import { refreshToken } from '../authStatus';

interface FailedRequest {
  resolve: (accessToken: string) => void;
  reject: (error?: any) => void;
}

class RefreshTokenQueue {
  private isRefreshing = false;

  private failedRequests: FailedRequest[] = [];

  public async attemptRefresh(): Promise<string> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      try {
        const newAccessToken = await refreshToken();
        this.onAccessTokenFetched(newAccessToken);
        return newAccessToken;
      } catch (error) {
        this.onAccessTokenRefreshedFailed(error);
        throw error;
      } finally {
        this.isRefreshing = false;
      }
    }

    return new Promise((resolve, reject) => {
      this.failedRequests.push({ resolve, reject });
    });
  }

  private onAccessTokenFetched(accessToken: string): void {
    this.failedRequests.forEach((request) => request.resolve(accessToken));
    this.clearQueue();
  }

  private onAccessTokenRefreshedFailed(error: any): void {
    this.failedRequests.forEach((request) => request.reject(error));
    this.clearQueue();
  }

  private clearQueue(): void {
    this.failedRequests = [];
  }
}

const refreshTokenQueue = new RefreshTokenQueue();

export default function refreshTokenHandler() {
  return refreshTokenQueue.attemptRefresh();
}
